import React, { Component, memo } from 'react';

import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withTranslation } from 'react-i18next';
import { IaCreators } from '../../../store/actions/intelligence';
import { BotsCreators } from '../../../store/actions/bots';
import { UserActions } from '../../../store/actions/users';

import IntelligenceCard from '../component/IntelligenceCard';
import IntelligenceSearch from '../component/IntelligenceSearch';
import CreateCard from '../component/CreateCard/CreateCard';
import EditIntelligenceCard from '../component/EditIntelligenceCard/EditIntelligenceCard';

import './Intencoes.scss';

class Intencoes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      create: false,
      edit: false,
      intentEdit: '',
      filterText: '',
    };
  }

  componentDidMount() {
    if (this.props.bot.currentTokenIa) {
      this.props.listAllSamples(this.props.bot.currentTokenIa, 'intent');
      this.props.listIAIntents(this.props.bot.currentTokenIa);
    }
  }

  newCard = () => {
    this.setState({
      create: !this.state.create,
    });
  };

  onEdit = () => {
    this.setState({
      edit: !this.state.edit,
    });
  };

  editItem = (intent) => {
    this.setState({
      intentEdit: intent,
      edit: !this.state.edit,
    });
  };

  deleteItem = (intent) => {
    const item = this.props.intents.find((item) => item.name === intent);
  };

  onChangeFilter = (e) => {
    this.setState({
      filterText: e.target.value,
    });
  };

  getDateIntent = (intent) => {
    const int = this.props?.intents?.find((int) => int.name === intent._id);
    if (int) return int.update;
    return new Date();
  };

  render() {
    const { blt, intents, samples, bot, user } = this.props;
    const { create, edit, intentEdit } = this.state;

    return (
      <div>
        {create === true && edit === false ? (
          <CreateCard newCard={this.newCard} blt={blt} />
        ) : (
          ''
        )}
        {edit === true && (
          <EditIntelligenceCard
            newCard={this.onEdit}
            blt={blt}
            label={intentEdit}
          />
        )}
        {create === false && edit === false ? (
          <div>
            <IntelligenceSearch
              user={user}
              bot={bot}
              blt={blt}
              newCard={this.newCard}
              onChangeFilter={this.onChangeFilter}
              filterText={this.state.filterText}
            />
            <div className="cards-all">
              {bot.iaEnabled &&
                samples
                  .filter((intent) => {
                    return intent._id.indexOf(this.state.filterText) >= 0;
                  })
                  .map((intent) => (
                    <IntelligenceCard
                      label={intent._id}
                      qtd={intent.samples}
                      user={user}
                      blt={blt}
                      updatedDate={this.getDateIntent(intent)}
                      editItem={this.editItem}
                      deleteItem={this.deleteItem}
                    />
                  ))}
              {bot.iaEnabled && samples.length === 0 && (
                <p
                  style={{ textAlign: 'center', width: '100%', marginTop: 15 }}
                >
                  Nenhuma intenção criada
                </p>
              )}
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ia: state.intelligence.ia,
  samples: state.intelligence.samples,
  intents: state.intelligence.intents,
  bot: state.bots.bot,
  user: state.users.signedUser,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...IaCreators,
      ...BotsCreators,
      ...UserActions,
    },
    dispatch
  );

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(memo(Intencoes)))
);
